export default __webpack_public_path__ + "static/media/attachment.a2350afa.svg";